import clsx from 'clsx';
import { FC, useContext, useEffect, useState } from 'react';

import styles from './main-page.module.scss';
// import './main-extra-styles.scss';
import { IMainPageProps } from './types';

import { CatalogMain, DiscountsBox, EBrands, ItemsBox, MainSlide } from '../../components';

import { Autoplay, Navigation, Pagination } from 'src/fork-components/swiper/modules/index.mjs';
import { Swiper, SwiperSlide } from 'src/fork-components/swiper/swiper-react';

import { removeCurrentData } from 'src/models';

import { DataContext, getMainSlides, TMainSlide } from '~utils';

export const MainPage: FC<IMainPageProps> = ({ className = '', ...rest }) => {
  const [slides, setSlides] = useState<TMainSlide[]>([]);

  const { latestSuggestedItems, bestsellersSuggestedItems, brands } = useContext(DataContext);

  useEffect(() => {
    removeCurrentData();

    getMainSlides().then(({ data }) => {
      const sortedSlides = data.reduce<TMainSlide[]>((acc, slide) => {
        return slide.main ? [slide, ...acc] : [...acc, slide];
      }, []);

      setSlides(sortedSlides);
    });
  }, []);

  return (
    <section className={clsx(styles.container, className)} {...rest}>
      <Swiper
        slidesPerView={1}
        spaceBetween={20}
        loop
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Navigation, Pagination]}
        className={styles.swiper}
      >
        {slides.map(item => (
          <SwiperSlide key={item.id}>
            <MainSlide data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={styles.main}>
        <CatalogMain />
        <ItemsBox type={EBrands.BRANDS} data={brands} />
        <ItemsBox type={EBrands.LATEST} data={latestSuggestedItems} />
        <ItemsBox type={EBrands.BESTSELLERS} data={bestsellersSuggestedItems} />
        <DiscountsBox />
      </div>
    </section>
  );
};
